<template>
  <div class="row">
    <div class="col-12">
      <h2>{{ $t('general_terms.create') }}</h2>
    </div>

    <div class="col-12 mt-4">
      <form class="row" @submit.prevent="createGeneralTerm">
        <FormFields v-model:formData="formData"/>
        <div class="col-12 col-lg-3 mt-3">
          <button class="btn btn-success" type="submit" :disabled="saving">
            {{ $t('save') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {useGeneralTermStore} from "@/stores/general_term";
import {Helpers} from "@/helpers";
import {ROUTES} from "@/scripts/constants";
import FormFields from "@/pages/general_terms/components/FormFields.vue";

export default {
  name: 'GeneralTermsCreate',
  components: {
    FormFields,
  },
  setup() {
    return {
      generalTermStore: useGeneralTermStore(),
    }
  },
  data() {
    return {
      formData: {
        key: '',
        title: '',
        content: '',
      },
      saving: false,
    }
  },
  created() {
    this.setTitle(this.$t('general_terms.create'))
  },
  methods: {
    buildPayload() {
      return {
        key: this.formData.key,
        title: this.formData.title,
        content: this.formData.content,
      }
    },
    createGeneralTerm() {
      this.saving = true
      this.generalTermStore.create(this.buildPayload()).then(({data}) => {
        Helpers.emitter.emit('success', this.$t('general_terms.created'))
        const id = data?.general_term?.id ?? data?.id
        if (id) {
          this.$router.push({name: ROUTES.GENERAL_TERMS.SHOW, params: {id}})
          return
        }
        this.$router.push({name: ROUTES.GENERAL_TERMS.INDEX})
      }).finally(() => {
        this.saving = false
      })
    }
  }
}
</script>
